"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Description = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns styled description of a category. On desktop is centered.
 * Renders if `description` has thruthy value.
 */ const Description = (param)=>{
    let { description, className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    if (!description) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        className: className,
        color: "textPrimary",
        "data-testid": getTestId(_constants.DESCRIPTION),
        children: description
    });
};
exports.Description = Description;
